import fetch from 'isomorphic-fetch';

export default function fetchJson(...params) {
  return fetch(...params)
    .then(async (response) => {
      const json = await response.json();
      if (!response.ok && json.type !== 'account-block') {
        throw Object.assign(new Error(), {json, response});
      }
      return {json, response};
    });
}



// WEBPACK FOOTER //
// ./spa/fetch-json.jsx